import { render } from "./CIS-ResourceExcerpt.vue?vue&type=template&id=16bc6d1d"
import script from "./CIS-ResourceExcerpt.vue?vue&type=script&lang=js"
export * from "./CIS-ResourceExcerpt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__